
import React, { useEffect, useState } from 'react'
import { Paragraph, SectionInfo } from 'types/Challenge'
import Typography from 'Components/Base/Typography'
import Row from 'Components/Base/Row'
import Column from 'Components/Base/Column'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function FQStep10({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {

    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2])))
    setStepParagraphs(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]))?.paragraphs)
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])


  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : '0px 60px 0px 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '0px 0px 30px' }}>
          <Typography variant='h1'>{sectionInfo?.titles.find((title) => title.titleId === 10)?.titleText ?? ''}</Typography>
        </Row>

        <li style={{ fontFamily: 'Raleway', marginBottom: 10, textIndent: '-1.5em', marginLeft: isMobile ? 30 : 50, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 11)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 25)?.paragraph ?? ''}</li>
        <li style={{ fontFamily: 'Raleway', marginBottom: 10, textIndent: '-1.5em', marginLeft: isMobile ? 30 : 50, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 12)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 26)?.paragraph ?? ''}</li>
        <li style={{ fontFamily: 'Raleway', marginBottom: 10, textIndent: '-1.5em', marginLeft: isMobile ? 30 : 50, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 13)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 27)?.paragraph ?? ''}</li>
        <li style={{ fontFamily: 'Raleway', marginBottom: 10, textIndent: '-1.5em', marginLeft: isMobile ? 30 : 50, fontSize: 20 }}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 28)?.paragraph ?? ''} <b>{sectionInfo?.titles.find((title) => title.titleId === 14)?.titleText ?? ''}</b></li>


      </Column>
      <Column styles={{ width: '100%', marginTop: isMobile ? '0px' : '40px' }}>
        <img src={sectionInfo?.images.find((image) => image.imageId === 11)?.url} alt='scale' style={{ width: isMobile ? '100%' : '454px', marginLeft: 'auto', border: '1px solid black' }} />
      </Column>
    </ResponsiveContainer>
  )
}

